<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex d-flex xs7 order-md1 pt-1>
        <v-card light tile raised color="white" style="min-height: 2000px; height: auto !important; height: 2000px;">
          <Pendingapplicationstitle v-if="applicationactivepage === 'pendingapplications'"></Pendingapplicationstitle>
          <Submittedapplicationstitle v-if="applicationactivepage === 'submittedapplications'"></Submittedapplicationstitle>
          <Verifiedapplicationstitle v-if="applicationactivepage === 'verifiedapplications'"></Verifiedapplicationstitle>
          <Approvedapplicationstitle v-if="applicationactivepage === 'approvedapplications'"></Approvedapplicationstitle>
          <Rejectedapplicationstitle v-if="applicationactivepage === 'rejectedapplications'"></Rejectedapplicationstitle>
          <Cancelledapplicationstitle v-if="applicationactivepage === 'cancelledapplications'"></Cancelledapplicationstitle>
          <Applicationlist ref="applicationlistref"></Applicationlist>
          <Applicationdetails></Applicationdetails>
        </v-card>
      </v-flex>
      <v-flex d-flex xs4 order-md2 pt-1>
        <v-card light tile raised color="white darken-4">
          <v-toolbar flat color="white darken-4" light style="border-bottom-style: solid; border-width: 1px; border-color: lightgrey !important;">
            <v-toolbar-title class="text-xs-center">Application files</v-toolbar-title>
          </v-toolbar>
          <Applicationattachments></Applicationattachments>
          <Applicationverificationfiles></Applicationverificationfiles>
          <Applicationcommitteefiles></Applicationcommitteefiles>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Pendingapplicationstitle from '@/components/dashboard/applications/Pendingapplicationstitle'
import Submittedapplicationstitle from '@/components/dashboard/applications/Submittedapplicationstitle'
import Verifiedapplicationstitle from '@/components/dashboard/applications/Verifiedapplicationstitle'
import Rejectedapplicationstitle from '@/components/dashboard/applications/Rejectedapplicationstitle'
import Approvedapplicationstitle from '@/components/dashboard/applications/Approvedapplicationstitle'
import Cancelledapplicationstitle from '@/components/dashboard/applications/Cancelledapplicationstitle'
import Applicationlist from '@/components/dashboard/applications/Applicationlist'
import Applicationdetails from '@/components/dashboard/applications/Applicationdetails'
import Applicationattachments from '@/components/dashboard/applications/Applicationattachments'
import Applicationverificationfiles from '@/components/dashboard/applications/Applicationverificationfiles'
import Applicationcommitteefiles from '@/components/dashboard/applications/Applicationcommitteefiles'

export default {
  computed: {
    applicationactivepage () {
      return this.$store.getters.getApplicationactivepage
    }
  },
  data () {
    return {
      showpage: false
    }
  },
  methods: {

  },
  // When created call start
  mounted () {

  },
  components: {
    Verifiedapplicationstitle,
    Pendingapplicationstitle,
    Submittedapplicationstitle,
    Cancelledapplicationstitle,
    Rejectedapplicationstitle,
    Approvedapplicationstitle,
    Applicationlist,
    Applicationdetails,
    Applicationattachments,
    Applicationverificationfiles,
    Applicationcommitteefiles
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/applications/Applicationlayout.vue